var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('combobox', {
    ref: "primaryInput",
    attrs: {
      "disabled": _vm.disabled,
      "errors": _vm.internalErrors,
      "internal-search": false,
      "is-loading": _vm.isLoading,
      "label": _vm.label,
      "multiple": _vm.multiple,
      "options": _vm.options,
      "value": _vm.internalValue
    },
    on: {
      "close": _vm.onClose,
      "input": _vm.onInput,
      "search": _vm.onSearch
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c00675d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductDesignCategoryCombobox.vue
// module id = 2004
// module chunks = 0